<template>
    <div class="" style="padding-bottom: 100px;">
        <Nav />
        <transition name="fade">
            <div class="container mt-4 content">
                <router-view>
                </router-view>
            </div>
        </transition>
        <Footer/>
    </div>
</template>

<script>
import Footer from '@/components/partials/Footer.vue';
import Nav from '@/components/partials/Nav.vue';

    export default {
        name:"AppLayout",
        components:{
            Nav,
            Footer
        }
    }
</script>